import { css } from 'styled-components';
import { media } from '@minecraft.themes';

export const iconSize = css`
  height: 1.375rem;
  width: 1.375rem;
`;

export const scrollableContainer = css`
  padding: 1rem 1.5rem;
  height: 100%;
  overflow-y: auto;
  width: 100%;

  ${media.sm`
    width: 50%;
  `}
`;
